/**
 * База API подставляется на этапе сборки из `VITE_API_BASE_URL`, а при её
 * отсутствии — из `NEXT_PUBLIC_API_URL` (её задают docker-compose и
 * infrastructure/docker/web.Dockerfile). Пустая строка означает «тот же origin»:
 * в dev запросы проксирует Vite.
 */
export const API_BASE_URL: string = __API_BASE_URL__;

/** Глобальный префикс NestJS-приложения (`app.setGlobalPrefix('api/v1')`). */
export const API_PREFIX = '/api/v1';

/**
 * Публичный endpoint tusd. Берётся из `VITE_TUS_URL`; сессия загрузки может
 * переопределить его через `tusEndpoint`.
 * 
 * По умолчанию используется относительный URL `/files/`, который работает через
 * прокси Vite (в dev) или через внешний reverse proxy (в production).
 * Можно задать абсолютный URL через VITE_TUS_URL, если tusd доступен напрямую.
 */
export const TUS_URL: string =
  (import.meta.env.VITE_TUS_URL as string | undefined)?.trim() ||
  '/files/';

/** Заголовок одноразового токена сессии загрузки (совпадает с UPLOAD_TOKEN_HEADER). */
export const UPLOAD_TOKEN_HEADER = 'X-Axium-Upload-Token';

/**
 * Приводит endpoint TUS к абсолютному URL для Uppy.
 * Относительный `/files/` резолвится от текущего origin страницы.
 */
export function resolveTusEndpoint(endpoint: string | null | undefined): string {
  const raw = endpoint?.trim() || TUS_URL;
  if (raw.startsWith('/')) {
    if (typeof window !== 'undefined' && window.location?.origin) {
      return new URL(raw, window.location.origin).href;
    }
    return raw;
  }
  return raw;
}

export function apiUrl(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${API_PREFIX}${normalized}`;
}
